import { useMemo } from 'react';
import { Transfer } from 'antd';
import { PaginationType } from 'antd/lib/transfer/interface';
import intersectionWith from 'lodash.intersectionwith';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { appRoute } from 'app/terminals/router/routes';

import { TEmployee } from '../../core/employee';

type TrasferEmployeeItem = Pick<TEmployee, 'id' | 'name'>;

type DataSourceItem = { key: string; title: string };

type UiSelectEmployeesProps = {
  items: TrasferEmployeeItem[];
  value: TrasferEmployeeItem[];
  loading?: boolean;
  onChange: (empl: TrasferEmployeeItem[]) => void;
};

const paginationSettings: PaginationType = {
  pageSize: 25,
  simple: false,
};

// eslint-disable-next-line mobx/missing-observer
const TransferItemRender = (record: DataSourceItem) => {
  const emplPath = appRoute.EMPLOYEE.buildPath({ id: Number(record.key) });
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <span>{record.title}</span>
      <Link to={emplPath}>Открыть профиль</Link>
    </div>
  );
};

export const UiSelectEmployees = observer(
  ({
    loading = false,
    items,
    value = [],
    onChange,
  }: UiSelectEmployeesProps) => {
    const dataSource: DataSourceItem[] = useMemo(
      () => items.map((item) => ({ key: String(item.id), title: item.name })),
      [items]
    );

    const targetKeys = useMemo(
      () => value.map((item) => String(item.id)),
      [value]
    );

    const handleOnChange = (selectedIds: string[]) => {
      const outputItems = intersectionWith(
        items,
        selectedIds,
        (item, selectedId) => String(item.id) === selectedId
      );

      onChange(outputItems);
    };

    return (
      <Transfer
        locale={{
          notFoundContent: (
            <div style={{ padding: '50px 0' }}>
              {loading ? 'Загрузка...' : 'Нет данных'}
            </div>
          ),
        }}
        listStyle={{ minWidth: 200, flexGrow: 2 }}
        titles={['Все', 'Добавленные']}
        targetKeys={targetKeys}
        dataSource={dataSource}
        onChange={handleOnChange}
        render={TransferItemRender}
        pagination={paginationSettings}
      />
    );
  }
);
